// Keep in sync with C:\work\BookMarkSearch\package.ps1 $Version
export const BOOKMARKSEARCH_VERSION = '1.1.0'
// Version code for download paths (dots removed), e.g. 1.0.0 -> 100
export const BOOKMARKSEARCH_VERSION_CODE = BOOKMARKSEARCH_VERSION.replace(/\./g, '')
export const BOOKMARKSEARCH_ZIP_NAME = `BookMarkSearch.${BOOKMARKSEARCH_VERSION}.zip`
export const BOOKMARKSEARCH_DOWNLOAD_BASE = 'https://www.searchplusplus.jp/download'
export const BOOKMARKSEARCH_DOWNLOAD_URL = `${BOOKMARKSEARCH_DOWNLOAD_BASE}/BookMarkSearch/${BOOKMARKSEARCH_VERSION_CODE}/${BOOKMARKSEARCH_ZIP_NAME}`
export const BOOKMARKSEARCH_PURCHASE_URL = 'https://buy.stripe.com/5kQ5kE9bMeC142IgeX9bO02?locale=ja'
export const BOOKMARKSEARCH_TRIAL_DAYS = 30

// Screenshot (compressed JPEG, ~130 KB; original PNG kept at project root)
export const BOOKMARKSEARCH_SCREENSHOT_URL = 'BookMarkSearch_screenshot.jpg'

// User manual PDFs (hosted at site root, same convention as manual.pdf)
export const BOOKMARKSEARCH_MANUAL_URL = 'BookMarkSearch_User_Guide.pdf'
export const BOOKMARKSEARCH_MANUAL_JA_URL = 'BookMarkSearch_User_Guide_JA.pdf'
